module Meevo.Components.UdfImageUpload {
    angular.module("meevo.components.udfImageUpload", []);
}
